/* Pillar blueprint sticky bar. GENERATED by .blueprint.mjs.
   Shows the "Book your call" bar until the calendar reaches the middle of the screen, and scrolls to it on tap.
   The trigger is a line at 45% of the viewport height: the bar is off only while the calendar frame crosses it.
   "Off screen" alone would not work, because with the header hidden the frame already peeks in at the bottom
   on first paint and the bar would never show on the short pages.
   The link is a real in-page anchor, so it still works if this script never runs. */
(function(){
  var bar = document.querySelector('[data-pb-sticky]'), target = document.getElementById('pb-book');
  if(!bar || !target) return;
  var cal = target.querySelector('.pb-cal') || target, link = bar.querySelector('a');
  document.documentElement.classList.add('pb-has-bar');
  if(link) link.addEventListener('click', function(e){
    e.preventDefault();
    try{ target.scrollIntoView({behavior:'smooth', block:'start'}); }catch(err){ target.scrollIntoView(); }
  });
  if(!('IntersectionObserver' in window)){ bar.classList.add('pb-on'); return; }
  new IntersectionObserver(function(entries){
    var e = entries[entries.length-1];
    bar.classList.toggle('pb-on', !e.isIntersecting);
  }, { threshold: 0, rootMargin: '-45% 0px -55% 0px' }).observe(cal);
})();
/* Top video (2026-10-07, Shane): a poster and a play button until tapped, so an idle player never loads a byte or
   takes a swipe. The sources are listed on the element and only become <source> children inside the tap, which is
   also what lets it play with sound. Without this script the button is a plain link to the video file. */
(function(){
  var b = document.querySelector('[data-pb-hero-play]'); if(!b) return;
  var v = b.parentNode.querySelector('video.pb-video'); if(!v) return;
  b.addEventListener('click', function(e){
    if(e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
    var list; try{ list = JSON.parse(v.getAttribute('data-pb-srcs')); }catch(err){ return; }
    if(!list || !list.length) return;
    e.preventDefault();
    list.forEach(function(x){ var s = document.createElement('source'); s.src = x[0]; s.type = x[1]; if(x[2]) s.media = x[2]; v.appendChild(s); });
    v.setAttribute('preload','auto'); v.setAttribute('controls',''); v.controls = true; v.removeAttribute('data-pb-idle');
    if(b.parentNode) b.parentNode.removeChild(b);
    try{ v.load(); }catch(err){}
    var p = v.play(); if(p && p.catch) p.catch(function(){});
  });
})();
/* Path pages: the banner for somebody arriving from the quiz (2026-10-07, Shane). The quiz sends them
   here with ?quiz=<id>&n=<first name>&s=<score>. No quiz id, or a score that is not 0 to 100, and the
   banner stays hidden. The name is cut to letters and written as text, never as markup. */
(function(){
  var el = document.querySelector('[data-pb-quizbanner]'); if(!el) return;
  var q; try{ q = new URLSearchParams(location.search); }catch(err){ return; }
  if(!/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(q.get('quiz') || '')) return;
  var s = q.get('s') || ''; if(!/^\d{1,3}$/.test(s) || Number(s) > 100) return;
  var n = (q.get('n') || '').replace(/[^A-Za-z\u00C0-\u024F' -]/g, '').replace(/\s+/g, ' ').trim().slice(0, 30);
  el.textContent = 'Thanks for taking the quiz' + (n ? ', ' + n : '') + '. Your top Legacy Path right now is ' + el.getAttribute('data-pb-quizbanner') + ' (' + Number(s) + '% match). Watch the quick video, then book your call below.';
  el.hidden = false;
  var sub = document.querySelector('.pb-hero .pb-sub'); if(sub) sub.style.display = 'none';
})();
/* Funnel pixel events (2026-10-08, Shane). One sender for the pillar pages and the call scheduled page.
   META: the store's own Meta pixel is put in this window by Shopify's Facebook app, a few seconds after load. An event
   waits for it (up to 5 seconds) and goes out THROUGH it, addressed to the one pixel id, so it carries the same
   visitor cookies as every other store event and nothing about the store pixel is changed. If the store pixel is not
   there in time, or the visitor is leaving right now (a tap on a button that opens Calendly), the event is sent
   straight to Meta as a plain request instead. This file never loads Meta's script itself: an earlier version did,
   raced the store's copy, lost an event and switched off the store pixel's own button tracking.
   TIKTOK: the store's TikTok pixel runs inside Shopify's sandbox where this page cannot reach it, so the pixel is
   loaded here with the store's id and sent ONLY the named events (no page view call).
   ONCE: the session flag is written BEFORE the event goes out, so a refresh or a back button cannot send it twice.
   CONSENT: a visitor who has declined marketing tracking gets no pixel loaded, no event and no flag, so the events
   go out if they later accept. */
(function(){
  function declined(){ try{ var cp = window.Shopify && Shopify.customerPrivacy; return !!(cp && typeof cp.marketingAllowed === 'function' && cp.marketingAllowed() === false); }catch(err){ return false; } }
  /* Shopify's consent reader is not on the page until asked for. Ask, then go on; never wait more than 2.5 seconds. */
  function whenConsentKnown(cb){
    var done = false, go = function(){ if(done) return; done = true; cb(); };
    try{
      if(window.Shopify && Shopify.customerPrivacy){ go(); return; }
      if(window.Shopify && typeof Shopify.loadFeatures === 'function'){ Shopify.loadFeatures([{ name:'consent-tracking-api', version:'0.1' }], go); setTimeout(go, 2500); return; }
    }catch(err){}
    go();
  }
  function cookie(n){ try{ var parts = ('; ' + document.cookie).split('; ' + n + '='); return parts.length > 1 ? parts[1].split(';')[0] : ''; }catch(err){ return ''; } }
  function sender(cfg){
    var META = /^[0-9]{6,20}$/.test(cfg.meta || '') ? cfg.meta : '', TT = /^[A-Z0-9]{10,40}$/.test(cfg.tiktok || '') ? cfg.tiktok : '';
    var out = cfg.state || {}, ttOn = false, data = { content_name: cfg.name, content_category: cfg.category || 'pillar page' };
    function warm(){
      if(ttOn || !TT) return; ttOn = true;
      try{ if(!(window.ttq && typeof window.ttq.track === 'function')){
        !function(w,d,t){w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"];ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e};ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{};ttq._i[e]=[];ttq._i[e]._u=r;ttq._t=ttq._t||{};ttq._t[e]=+new Date;ttq._o=ttq._o||{};ttq._o[e]=n||{};n=d.createElement("script");n.type="text/javascript";n.async=!0;n.src=r+"?sdkid="+e+"&lib="+t;e=d.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)}}(window,document,'ttq');
        window.ttq.load(TT);
      } }catch(err){}
    }
    function storePixelReady(){
      try{ if(typeof window.fbq !== 'function' || typeof window.fbq.getState !== 'function') return false;
        var px = window.fbq.getState().pixels || []; for(var i = 0; i < px.length; i++) if(String(px[i].id) === META) return true; }catch(err){}
      return false;
    }
    function direct(ev){
      var e = encodeURIComponent, u = 'https://www.facebook.com/tr/?id=' + META + '&ev=' + ev + '&dl=' + e(location.href) + '&rl=' + e(document.referrer || '') + '&if=false&ts=' + Date.now();
      for(var k in data) u += '&cd[' + k + ']=' + e(data[k]);
      var fbp = cookie('_fbp'), fbc = cookie('_fbc'); if(fbp) u += '&fbp=' + e(fbp); if(fbc) u += '&fbc=' + e(fbc);
      try{ if(window.fetch){ fetch(u, { mode:'no-cors', keepalive:true, credentials:'include' }).catch(function(){}); return; } }catch(err){}
      new Image().src = u;
    }
    function send(ev, flag, leaving){
      var st = out[ev] = { meta:'off', tiktok:'off' }, key = flag || ('pb-track:' + cfg.key + ':' + ev);
      try{ if(sessionStorage.getItem(key)){ st.meta = st.tiktok = 'already sent this session'; return; } }catch(err){ st.meta = st.tiktok = 'no session storage, not sent'; return; }
      if(declined()){ st.meta = st.tiktok = 'marketing tracking declined'; return; }
      try{ sessionStorage.setItem(key, String(Date.now())); }catch(err){ st.meta = st.tiktok = 'no session storage, not sent'; return; }
      try{
        if(!TT) st.tiktok = 'no pixel id';
        else { warm(); window.ttq.track(ev, data); st.tiktok = 'sent on pixel ' + TT; }
      }catch(err){ st.tiktok = 'error: ' + (err && err.message); }
      try{
        if(!META){ st.meta = 'no pixel id'; return; }
        if(storePixelReady()){ window.fbq('trackSingle', META, ev, data); st.meta = 'sent on the store pixel'; return; }
        if(leaving){ direct(ev); st.meta = 'sent direct, the store pixel was not ready'; return; }
        st.meta = 'waiting for the store pixel';
        var n = 0, open = true, bye = function(){ if(!open) return; open = false; clearInterval(t); direct(ev); st.meta = 'sent direct, the visitor left before the store pixel was ready'; };
        var t = setInterval(function(){
          if(!open) return;
          if(storePixelReady()){ open = false; clearInterval(t); window.removeEventListener('pagehide', bye); window.fbq('trackSingle', META, ev, data); st.meta = 'sent on the store pixel'; }
          else if(++n >= 25){ open = false; clearInterval(t); window.removeEventListener('pagehide', bye); direct(ev); st.meta = 'sent direct, no store pixel after 5 seconds'; }
        }, 200);
        window.addEventListener('pagehide', bye);
      }catch(err){ st.meta = 'error: ' + (err && err.message); }
    }
    return { send: send, warm: warm, state: out };
  }
  /* The call scheduled page (sections/pillar-scheduled.liquid) sends Schedule through this. */
  window.pbPixels = { sender: sender, declined: declined, whenConsentKnown: whenConsentKnown };

  /* Pillar pages. Runs only where the page's row in .blueprint.mjs carries `track`.
     ViewContent: once per tab session, on load. Lead: once per tab session, on the first tap on a "Book your call"
     button (the bar, the button under the results, the phone button, the fallback link) or the first use of the
     Calendly embed (a click into its frame, or Calendly reporting a picked time or a booking).
     DOES NOT know whether a Lead went on to book: that is Schedule, on the scheduled page. */
  var root = document.querySelector('[data-pb-track]'); if(!root) return;
  var cfg; try{ cfg = JSON.parse(root.getAttribute('data-pb-track')); }catch(err){ return; }
  if(!cfg || !cfg.key || !cfg.name || !cfg.events || !cfg.events.length) return;
  var state = window.__pbTrack = { warmed:false }; cfg.state = state;
  var px = sender(cfg), on = function(ev){ return cfg.events.indexOf(ev) >= 0; };
  /* TikTok's script is fetched at page load, not at the tap: the phone button leaves for Calendly at once, and an
     event queued behind a script that has not arrived would be lost with the page. */
  whenConsentKnown(function(){
    if(declined()) state.warmed = 'marketing tracking declined'; else { px.warm(); state.warmed = true; }
    if(on('ViewContent')) px.send('ViewContent');
  });
  if(!on('Lead')) return;
  document.addEventListener('click', function(e){
    if(e.target.closest && e.target.closest('a[href="#pb-book"], .pb-cal-mobile, .pb-cal-fallback a')) px.send('Lead', null, true);
  }, true);
  window.addEventListener('message', function(e){
    if(e.origin !== 'https://calendly.com') return; var d = e.data;
    if(d && typeof d.event === 'string' && (d.event === 'calendly.date_and_time_selected' || d.event === 'calendly.event_scheduled')) px.send('Lead', null, true);
  });
  window.addEventListener('blur', function(){
    setTimeout(function(){ var a = document.activeElement; if(a && a.tagName === 'IFRAME' && a.closest && a.closest('.calendly-inline-widget')) px.send('Lead', null, true); }, 0);
  });
})();
